<script lang="jsx">
import { authComputed } from '@state/helpers'
import NavBarRoutes from './nav-bar-routes'
import appConfig from '@src/app.config'
import BaseIcon from './_base-icon'
import { BAlert, BBadge, BNavbar, BNavbarNav, BModal } from 'bootstrap-vue-next'

export default {
  components: { BAlert, BBadge, BNavbar, BNavbarNav, BModal, NavBarRoutes },
  data() {
    return {
      appTitle: appConfig.title,
      persistentNavRoutes: [
        {
          name: 'content-about',
          title: 'Home',
        },
        {
          name: 'content-resources',
          title: 'Resources',
        },
      ],
      loggedInNavRoutes: [
        {
          name: 'property-map',
          title: 'Properties',
        },
        {
          name: 'logout',
          title: (h) => [<BaseIcon name="sign-out-alt" />, ' Log out'],
        },
      ],
      loggedOutNavRoutes: [
        {
          name: 'property-map',
          title: (h) => [<BaseIcon name="sign-in-alt" />, ' Log in'],
        },
      ],
      mobileNavOpen: false,
    }
  },
  computed: {
    ...authComputed,
  },
  methods: {
    goResources() {
      window.location.href = 'https://www.ohlink.org/resources'
    },
    showNew() {
      this.$refs.whatsnew.show()
    },
  },
}
</script>

<template>
  <!--<nav :class="$style.container">
    <h1 :class="$style.appTitle">
      <img src="~@assets/images/oh-link-logo.png" alt="Oakland Housing Link Logo">
      <span :class="$style.long">{{ appTitle }}</span>
      <span :class="$style.short">OH Link</span>
    </h1>
    <transition>-->
  <BNavbar toggleable="lg" type="light" variant="light">
    <!--<b-navbar-brand href="#">Oakland Housing Link</b-navbar-brand>-->
    <a class="navbar-brand" href="#">
      <img
        src="~@assets/images/ohlink_icon.svg"
        width="30"
        height="30"
        class="d-inline-block align-middle"
        alt="oakland housing link icon"
      />
      <span style="padding-left: 10px; vertical-align: middle"
        ><strong>Oakland Housing Link</strong></span
      >
    </a>

    <BNavbarNav class="ml-auto">
      <ul :class="[$style.links, { [$style.open]: mobileNavOpen }]">
        <!-- <a id="showBtn" href="#" style="margin-right: 20px;" @click="goResources()"><b-badge variant="danger" ><span style="font-size: 1.2em">What's New?</span></b-badge></a> -->
        <a id="showBtn" href="#" style="margin-right: 20px" @click="showNew()"
          ><BBadge variant="danger"
            ><span style="font-size: 1.2em">What's New?</span></BBadge
          ></a
        >
        <NavBarRoutes :routes="persistentNavRoutes" />
        <NavBarRoutes v-if="loggedIn" :routes="loggedInNavRoutes" />
        <NavBarRoutes v-else :routes="loggedOutNavRoutes" />
      </ul>
      <!--</transition>-->
      <BaseButton
        :class="$style.mobileMenuButton"
        aria-label="Toggle mobile menu"
        @click="mobileNavOpen = !mobileNavOpen"
      >
        <BaseIcon name="bars" />Menu
      </BaseButton>
      <!--</nav>-->
      <BModal
        id="newmodal"
        ref="whatsnew"
        size="md"
        hide-footer
        header-bg-variant="light"
      >
        <template v-slot:modal-title>
          <span :class="$style.whatsnewtitle">What's New?</span>
        </template>
        <BAlert show variant="danger"
          ><strong>Looking for housing?</strong> Check out CHN's
          <a
            href="https://communityhousingnetwork.org/other-services/"
            target="_blank"
            style="color: #dc3545; text-decoration: underline"
            >list of services</a
          >
          provided by other organizations, including subsidized housing
          lists.</BAlert
        >
        <BAlert show variant="primary"
          ><strong>Join our Roommate Database:</strong> Looking for people to
          share housing with? Call 248-824-7410 and one of our housing brokers
          will help!</BAlert
        >
      </BModal>
    </BNavbarNav>
  </BNavbar>
</template>

<style lang="scss" module>
@import '@design';

.container {
  position: relative;
  display: flex;
  align-items: center;
  padding: $size-grid-padding;
  background-color: #f1f0ee;
}

.appTitle,
.links {
  display: flex;
  align-items: center;
}

.appTitle {
  @include typography-got-rhythm(0);

  flex-shrink: 0;
  margin: 0;
  line-height: 1;

  img {
    height: 1em;
    margin-top: -1px;
    margin-right: $size-grid-padding * 0.5;
  }
  .short {
    display: none;
  }
  .long {
    display: inline;
  }

  @media only screen and (max-width: $size-breakpoint-sm) {
    img {
      display: none;
    }
    .short {
      display: inline;
    }
    .long {
      display: none;
    }
  }
}

.links {
  justify-content: flex-end;
  width: 100%;
  padding: 0;
  margin: 0;
  text-align: right;
  list-style-type: none;

  > li {
    display: inline-block;
    margin-right: $size-grid-padding;
    vertical-align: middle;

    &:last-child {
      margin-right: 0;
    }
  }

  a {
    vertical-align: text-bottom;
  }

  @media only screen and (max-width: $size-breakpoint-sm) {
    position: absolute;
    top: 100%;
    right: -91vw;
    z-index: $layer-modal-z-index;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-start;
    width: auto;
    max-width: 90vw;
    height: calc(100vh - 100%);
    max-height: calc(100vh - 100%);
    padding: 0 $size-grid-padding $size-grid-padding;
    overflow-y: scroll;
    pointer-events: none;
    background: white;
    border-left: 1px solid #ddd;
    opacity: 0;
    transition: all 0.4s ease-in;
    backface-visibility: hidden;
    perspective: 1000;
    transform: translate3d(0, 0, 0);

    > li {
      display: block;
      margin: $size-grid-padding 0 0;

      &:first-child {
        margin-top: $size-grid-padding * 0.5;
      }
    }

    &.open {
      right: 0;
      pointer-events: all;
      opacity: 1;
      transition: all 0.4s ease-out;
    }
  }
}

.mobileMenuButton.mobileMenuButton {
  display: none;
  flex-shrink: 0;
  padding: $size-grid-padding * 0.4 $size-grid-padding * 0.5;
  margin-left: auto;
  line-height: 1;

  @media only screen and (max-width: $size-breakpoint-sm) {
    display: block;
  }
}

.whatsnew {
  padding-right: 20px;
}

.whatsnewtitle {
  font-size: 110%;
  font-weight: bold;
}
</style>
